export enum CURRENCY {
  CHF = 'CHF',
  EUR = 'EUR',
}

export enum TYPE {
  SEAT = 'SEAT',
  MEMBER = 'MEMBER',
}

export interface BuyerSeatDto {
  id: number;
  name: string;
  tenantId: string;
  buyerSeatId: string;
  ssp: string;
  dsp: string;
  dspId: number;
  createdDate: string;
  modifiedDate: string;
  currency: CURRENCY;
  type: TYPE;
  buyerSeatNameAndId: string; // frontend specific
}

export interface BuyerSeatOverviewDto {
  id: number;
  buyerSeatId: string;
  name: string;
  organization: string;
  ssp: string;
  dealsCount: number;
  status: string;
  createdAt: string;
}

export interface BuyerSeatListPageDto {
  buyerSeats: BuyerSeatOverviewDto[];
  total: number;
}

export interface BuyerSeatDetailDto {
  id: number;
  buyerSeatId: string;
  name: string;
  tenantId: string;
  organizationName: string;
  ssp: string;
  status: string;
  createdAt: string;
  dealsCount: number;
  disabled: boolean;
}

export interface BuyerSeatUpdateDto {
  name?: string;
  ssp?: string;
  disabled?: boolean;
  tenantId?: string;
}
